module.exports = __webpack_public_path__ + "img/img_banner_size01.fa6844de.svg";